import cloneDeep from 'lodash/cloneDeep';

export default function transform(serverTableData) {
  const copy = cloneDeep(serverTableData);

  if (!copy.page) copy.page = 1;
  if (!copy.limit) copy.limit = 100;

  if (copy.query) {
    Object.keys(copy.query).forEach(key => {
      if (typeof copy.query[key] !== 'string') return;
      copy.query[key] = copy.query[key].trim();
    });
  }

  const inputServer = {
    Query: copy.query,
    Inclusion: copy.inclusion,
    MaxResultCount: copy.limit,
    SkipCount: (copy.page - 1) * copy.limit,
  };

  if (copy.orderBy) {
    const order = !copy.ascending ? ' DESC' : ' ASC';
    inputServer.Sorting = copy.orderBy + order;
  }
  
  if (copy.sorting) inputServer.Sorting = copy.sorting;
  return inputServer;
}
